/* ============================================================
   SST — Product page
   Variant pills → resolve variant (id/price/save/availability),
   draggable/swipeable gallery, thumbnail sync, quantity stepper.
   Add-to-Cart uses Dawn's <product-form> (opens cart drawer).
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-sst-product]');
    if (!root) return;

    var variants = parseVariants(root);

    // ---- Variant pills ----
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('.sst-pdp__pill');
      if (pill) { selectPill(pill); resolveVariant(root, variants); }
    });

    // ---- Gallery thumbnails ----
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-sst-thumb]');
      if (thumb) showSlide(root, thumb.getAttribute('data-index'));
    });

    // ---- Gallery: swipe / drag + scroll sync ----
    initGallery(root);

    // ---- Quantity stepper ----
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sst-qty-minus]')) stepQty(root, -1);
      if (e.target.closest('[data-sst-qty-plus]')) stepQty(root, 1);
    });
  }

  /* Draggable/swipeable stage. Mobile = native touch scroll-snap.
     Desktop = pointer drag-to-scroll. Scroll position → active thumb. */
  function initGallery(root) {
    var stage = root.querySelector('.sst-pdp__stage');
    if (!stage) return;

    // Sync active thumb with the most-visible slide on scroll.
    var raf;
    stage.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var idx = Math.round(stage.scrollLeft / stage.clientWidth);
        setActiveThumb(root, String(idx));
      });
    });

    // Pointer drag-to-scroll (desktop mouse; touch uses native scroll snap).
    var down = false, startX = 0, startScroll = 0, moved = false, pid = null;

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // native touch scroll handles swipe
      down = true; moved = false;
      startX = e.clientX;
      startScroll = stage.scrollLeft;
      pid = e.pointerId;
      // Capture so pointermove keeps firing even outside the stage bounds.
      try { stage.setPointerCapture(pid); } catch (err) {}
      stage.classList.add('is-dragging');
      e.preventDefault();
    });

    stage.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      stage.scrollLeft = startScroll - dx;
    });

    function end() {
      if (!down) return;
      down = false;
      stage.classList.remove('is-dragging');
      if (pid != null) { try { stage.releasePointerCapture(pid); } catch (err) {} pid = null; }
      // Snap to nearest slide after a free drag.
      scrollToSlide(stage, Math.round(stage.scrollLeft / stage.clientWidth));
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);

    // Suppress the click that fires right after a drag (would follow image link).
    stage.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function parseVariants(root) {
    try { return JSON.parse(root.getAttribute('data-variants')); } catch (e) { return []; }
  }

  function selectPill(pill) {
    var group = pill.closest('.sst-pdp__option');
    group.querySelectorAll('.sst-pdp__pill').forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');
  }

  function resolveVariant(root, variants) {
    var chosen = [];
    root.querySelectorAll('.sst-pdp__option').forEach(function (opt) {
      var active = opt.querySelector('.sst-pdp__pill.is-active');
      chosen.push(active ? active.getAttribute('data-value') : null);
    });

    var match = variants.find(function (v) {
      return chosen.every(function (val, i) { return val == null || v.options[i] === val; });
    });
    if (!match) return;

    // Hidden id
    var idInput = root.querySelector('[data-sst-variant-id]');
    if (idInput) { idInput.value = match.id; idInput.disabled = !match.available; }

    // Price + compare + save
    var priceEl = root.querySelector('[data-sst-price]');
    var compareEl = root.querySelector('[data-sst-compare]');
    var saveEl = root.querySelector('[data-sst-save]');
    if (priceEl) priceEl.textContent = money(match.price);
    if (compareEl && saveEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = money(match.compare_at_price);
        compareEl.hidden = false;
        saveEl.textContent = 'Save ' + money(match.compare_at_price - match.price);
        saveEl.hidden = false;
      } else {
        compareEl.hidden = true;
        saveEl.hidden = true;
      }
    }

    // ATC state
    var atc = root.querySelector('[data-sst-atc]');
    var atcText = root.querySelector('[data-sst-atc-text]');
    if (atc) atc.disabled = !match.available;
    if (atcText) atcText.textContent = match.available ? 'Add to Cart' : 'Sold Out';

    // Swap main image to the variant's featured media
    if (match.featured_media && match.featured_media.position != null) {
      showSlide(root, String(match.featured_media.position - 1));
    }

    // Reflect in URL (like Dawn) without reload
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }
  }

  /* Scroll the draggable stage to a slide (thumbnail click / variant swap). */
  function showSlide(root, index) {
    var stage = root.querySelector('.sst-pdp__stage');
    if (stage) scrollToSlide(stage, parseInt(index, 10) || 0);
    setActiveThumb(root, index);
  }

  function scrollToSlide(stage, idx) {
    stage.scrollTo({ left: idx * stage.clientWidth, behavior: 'smooth' });
  }

  function setActiveThumb(root, index) {
    root.querySelectorAll('[data-sst-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-index') === index);
    });
  }

  function stepQty(root, delta) {
    var input = root.querySelector('[data-sst-qty]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = Math.max(1, v + delta);
    input.value = v;
  }

  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
